export const SORT_ASC = 'ASC';
export const SORT_DESC = 'DESC';
export type SortDirection = 'ASC' | 'DESC';
